const messages = {
  title: "Multiplicateur de bonus",
  bandBonusTitle: "Bonus par pneu avec multiplicateur",
  amountLabel: "Nombre min. de pneus (*)",
  label: "Multiplicateur de bonus",
  desc: "Nombre de pneus Bridgestone et Firestone. Il n’y a pas de bonus en euros sur les pneus Firestone.",
  goals: {
    loyal: "Fidèle",
    bronze: "Bronze",
    silver: "Argent",
    gold: "Or",
    platinum: "Platine",
  },
  andMore: "et plus",
  chooseTarget: "Sélectionner",
  selectTarget: "Sélectionnez ici votre objectif annuel {year} :",
  multiplication: "Le bonus est multiplié par <b>{factor}</b>",
  minTyres: "<b>Minimum :</b> {tyre} pneus",
};

export default {
  messages,
};
